// Auto-generated by scripts/export-abis.js — do not edit manually
// Run `npm run build -w @sof/contracts` to regenerate

import _Raffle from './Raffle.json' with { type: 'json' };
import _RafflePositionTracker from './RafflePositionTracker.json' with { type: 'json' };
import _RafflePrizeDistributor from './RafflePrizeDistributor.json' with { type: 'json' };
import _RaffleToken from './RaffleToken.json' with { type: 'json' };
import _InfoFiMarket from './InfoFiMarket.json' with { type: 'json' };
import _InfoFiMarketFactory from './InfoFiMarketFactory.json' with { type: 'json' };
import _InfoFiPriceOracle from './InfoFiPriceOracle.json' with { type: 'json' };
import _InfoFiSettlement from './InfoFiSettlement.json' with { type: 'json' };
import _MarketTypeRegistry from './MarketTypeRegistry.json' with { type: 'json' };
import _RaffleOracleAdapter from './RaffleOracleAdapter.json' with { type: 'json' };
import _InfoFiFPMMV2 from './InfoFiFPMMV2.json' with { type: 'json' };
import _SimpleFPMM from './SimpleFPMM.json' with { type: 'json' };
import _SOLPToken from './SOLPToken.json' with { type: 'json' };
import _ConditionalTokenSOF from './ConditionalTokenSOF.json' with { type: 'json' };
import _SOFBondingCurve from './SOFBondingCurve.json' with { type: 'json' };
import _SeasonFactory from './SeasonFactory.json' with { type: 'json' };
import _SeasonGating from './SeasonGating.json' with { type: 'json' };
import _ERC20 from './ERC20.json' with { type: 'json' };
import _AccessControl from './AccessControl.json' with { type: 'json' };
import _Hats from './Hats.json' with { type: 'json' };
import _StakingEligibility from './StakingEligibility.json' with { type: 'json' };
import _RolloverEscrow from './RolloverEscrow.json' with { type: 'json' };
import _TokenLaunchpad from './TokenLaunchpad.json' with { type: 'json' };
import _LaunchToken from './LaunchToken.json' with { type: 'json' };
import _UniV4LiquidityPlacer from './UniV4LiquidityPlacer.json' with { type: 'json' };
import _PoolManager from './PoolManager.json' with { type: 'json' };
import _ILaunchRouter from './ILaunchRouter.json' with { type: 'json' };
import _UniV4LaunchRouter from './UniV4LaunchRouter.json' with { type: 'json' };

// Helper: extract abi array from Foundry JSON or return as-is
const e = (json) => json.abi || json;

export const RaffleABI = e(_Raffle);
export const RafflePositionTrackerABI = e(_RafflePositionTracker);
export const RafflePrizeDistributorABI = e(_RafflePrizeDistributor);
export const RaffleTokenABI = e(_RaffleToken);
export const InfoFiMarketABI = e(_InfoFiMarket);
export const InfoFiMarketFactoryABI = e(_InfoFiMarketFactory);
export const InfoFiPriceOracleABI = e(_InfoFiPriceOracle);
export const InfoFiSettlementABI = e(_InfoFiSettlement);
export const MarketTypeRegistryABI = e(_MarketTypeRegistry);
export const RaffleOracleAdapterABI = e(_RaffleOracleAdapter);
export const InfoFiFPMMV2ABI = e(_InfoFiFPMMV2);
export const SimpleFPMMABI = e(_SimpleFPMM);
export const SOLPTokenABI = e(_SOLPToken);
export const ConditionalTokenSOFABI = e(_ConditionalTokenSOF);
export const SOFBondingCurveABI = e(_SOFBondingCurve);
export const SeasonFactoryABI = e(_SeasonFactory);
export const SeasonGatingABI = e(_SeasonGating);
export const ERC20ABI = e(_ERC20);
export const AccessControlABI = e(_AccessControl);
export const HatsABI = e(_Hats);
export const StakingEligibilityABI = e(_StakingEligibility);
export const RolloverEscrowABI = e(_RolloverEscrow);
export const TokenLaunchpadABI = e(_TokenLaunchpad);
export const LaunchTokenABI = e(_LaunchToken);
export const UniV4LiquidityPlacerABI = e(_UniV4LiquidityPlacer);
export const PoolManagerABI = e(_PoolManager);
export const ILaunchRouterABI = e(_ILaunchRouter);
export const UniV4LaunchRouterABI = e(_UniV4LaunchRouter);
